import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'statistics-cap-text',
    templateUrl: './statistics-cap-text.component.html',
    styleUrls: ['./statistics-cap-text.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class StatisticsCapTextComponent {}
